import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { InvoiceService } from '../../services/invoice.service';
import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Customer } from '../../../agatextscreens/accounting/customer';
import { Branch } from '../../../agatextscreens/accounting/branch';
import { AuthenticationService } from '../../services/authentication.service';
import { CustomerService } from '../../../agatextscreens/accounting/customer/customer.service';

@Component({
  selector: 'app-new-credit-dialog',
  templateUrl: './new-credit-dialog.component.html',
  styleUrls: ['./new-credit-dialog.component.scss'],
  providers: [InvoiceService, CustomerService]
})
export class NewCreditDialogComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();

  customer_id: number;
  branch_id: number;
  invoice_date: string;
  type: string = 'Credit';
  total: number;

  allBranches$: Observable<Branch[]>;
  allCustomers$: Observable<Customer[]>;

  constructor(private _invoiceService: InvoiceService,
    private _customerService: CustomerService,
    private _dialogRef: MdDialogRef<NewCreditDialogComponent>,
    private _authService: AuthenticationService) { }

  ngOnInit() {
    //this.allBranches$ = this._invoiceService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
    this.allCustomers$ = this._customerService.getCustomers();

    this.invoice_date = new Date().toISOString().substr(0, 10);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  performAction(_do: boolean) {
    if (_do) {
      this.subscription.add(
        this._invoiceService.createInvoice(this.customer_id, this.branch_id, this.invoice_date, this.type, -this.total).subscribe(
          response => {

          }
        )
      );
      this._dialogRef.close(_do);
    } else {
      this._dialogRef.close(_do);
    }
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/dialogs/new-credit-dialog/new-credit-dialog.component.ts